import {
  DatahubEntity,
  IDefaultSchema,
  DATA_VERSION,
  CaptureEventData,
  CaptureEvent,
  IDefaultEventParams,
  UserEventTriggerAction,
  IUserEventTriggerSchema,
  UserEventTriggerType,
  UserEventTriggerName,
} from 'src/interfaces/Datahub';
import userEventTriggerSchema from './schema';

class UserEventTrigger {
  private defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  get schema() {
    return userEventTriggerSchema;
  }

  measure(
    captureEvent: CaptureEvent<UserEventTriggerAction>,
    params: { event: UserEventTriggerName; trigger: UserEventTriggerType } & IDefaultEventParams,
  ) {
    const event: IUserEventTriggerSchema = {
      ...this.defaultData,
      event: params.event,
      trigger: params.trigger,
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['1.0'],
    };

    captureEvent(DatahubEntity.USER_EVENT_TRIGGER, UserEventTriggerAction.MEASURE, data);
  }
}
export default UserEventTrigger;
